export default "__VITE_ASSET__DHOYEbG4__"